<template>
   	<div class="rankBg">
		<ul class="rank_list">
			<li v-for="(item,index) in singerList" @click="toSingerInfo(index)">
				<div class="image"><img :src="item.imgUrl" alt="" /></div>
				<div class="text">{{item.name}}</div>
				<div class="icon"><img src="../assets/images/arrow_icon.png" alt="" /></div>
			</li>
		</ul>
   		<div class="rankTitle" id="rankTitle">
   			<i @click="back"><img src="../assets/images/goback_1.png"/></i>
   			<h2>{{rankTime}}</h2>
   		</div>
   	</div>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
		
      }
    },
    computed: {
    	...mapGetters(['singerList','rankTime'])
    },
    components:{

  	},
  	mounted:function(){
    	
    },
    methods: {
      back(){
      	this.$router.go(-1);
      	this.$store.commit('setIscurrent', -1);
      	//this.$store.commit('navShow', true);
      },
      toSingerInfo(index){
      	this.$store.commit('rankPageIndex',index);
      	this.$router.push({path: '/singer_info'});
      }
    }
  }
</script>

<style scoped>
.rankBg{background: url(../../dist/bg01.jpg);width: 100%;height: 100%;background-size: 15%;}
.rank_list{background: url(../../dist/bg01.jpg);background-size: 15%;width: 100%;overflow: hidden;padding-left: 20px;box-sizing: border-box;position: absolute;top:129px;}
.rank_list li{width: 100%;overflow: hidden;border-bottom: 1px solid #333;margin-bottom: 18px;}
.rank_list li>div{float: left;margin-bottom: 14px;width: 80px;height: 64px;line-height: 64px;color: #ccc;font-size: 16px;margin-left: 10px;}
.rank_list .text{width: 40%;margin-left: 14px;}
.rank_list li img{width: 60px;}
.rank_list .icon{width: 12px;float:right;margin-right: 24px;margin-left: 0;}
.rank_list .icon img{width: 8px;margin-top: 27px;}
.rankTitle{background: #000;}
</style>


// WEBPACK FOOTER //
// singer_list.vue?2cf88f8a